import PropTypes from 'prop-types';

import Presenter from 'utils/PropTypesPresenter';

export default new Presenter({
  hash: PropTypes.string,
  pathname: PropTypes.string,
  search: PropTypes.string,
});
